import * as types from "../actions/ActionTypes";
export default function GetReducer(state = [], action) {
  const { type } = action;

  switch (type) {
    case types.GET_DATA:
      return state;
    default:
      return [];
  }
}
